import { createFileRoute } from "@tanstack/react-router";
import { isGuestTier } from "@salestrak/permissions";
import { Box } from "@salestrak/ui";
import { Dashboard } from "#app/widgets/dashboards/dashboard";
import {
  GUEST_MY_WORK_WIDGETS,
  MY_WORK_WIDGETS,
} from "#app/widgets/dashboards/my-work-widgets";
import { DashboardBoardSkeletonPane } from "#app/widgets/dashboards/dashboard-board-skeleton";
import { useAppData } from "#app/lib/data";

/**
 * `/my-work` — the current user's personal widget view, member-scoped to issues
 * assigned to them (`{ kind: "member", memberId: currentUser.userId }`). It's the
 * member-scoped host of the shared {@link Dashboard}, run in MANAGED mode: a
 * fixed, curated catalog (`MY_WORK_WIDGETS`, or its guest slice) the user only
 * toggles on/off — not a free add-any-widget board.
 */
function MyWorkScreen() {
  const { currentUser } = useAppData();
  // A guest-tier viewer can never post an Update (Guest's `create.items` is a
  // locked "no"), so their catalog drops the update-verb cards — and the
  // managed maintenance retires any instance a fuller catalog already seeded.
  const catalog = isGuestTier(currentUser?.roles)
    ? GUEST_MY_WORK_WIDGETS
    : MY_WORK_WIDGETS;
  if (!currentUser?.userId) {
    // The `me` payload is not in yet: the board silhouette holds the pane so
    // the page never sits blank waiting for it.
    return <DashboardBoardSkeletonPane managed />;
  }
  return (
    <Box direction="column" fill="flex" minHeight={0}>
      <Dashboard
        scope={{ kind: "member", memberId: currentUser.userId }}
        managedCatalog={catalog}
        title="My Work"
      />
    </Box>
  );
}

export const Route = createFileRoute("/(app)/$workspace/my-work")({
  component: MyWorkScreen,
});
